import { chatDebugLog } from "./chatDebug";

/**
 * Safe wrapper for localStorage and sessionStorage
 */
export const storage = {
    get: (key, type = 'local') => {
        try {
            const storage = type === 'local' ? window.localStorage : window.sessionStorage;
            if (!storage) return null;
            const value = storage.getItem(key);
            chatDebugLog('guestHistory', '[guest-history] storage:get', {
                key,
                type,
                hasValue: value !== null,
                valueLength: typeof value === 'string' ? value.length : 0,
            });
            return value;
        } catch (e) {
            console.error(`[guest-history] storage:get-failed:${type}`, {
                key,
                error: e?.message || String(e),
            });
            return null;
        }
    },
    set: (key, value, type = 'local') => {
        try {
            const storage = type === 'local' ? window.localStorage : window.sessionStorage;
            if (!storage) return;
            storage.setItem(key, value);
            const storedValue = storage.getItem(key);
            chatDebugLog('guestHistory', '[guest-history] storage:set', {
                key,
                type,
                inputLength: typeof value === 'string' ? value.length : 0,
                stored: storedValue === value,
                storedLength: typeof storedValue === 'string' ? storedValue.length : 0,
            });
        } catch (e) {
            console.error(`[guest-history] storage:set-failed:${type}`, {
                key,
                error: e?.message || String(e),
                valueLength: typeof value === 'string' ? value.length : 0,
            });
        }
    },
    remove: (key, type = 'local') => {
        try {
            const storage = type === 'local' ? window.localStorage : window.sessionStorage;
            if (!storage) return;
            storage.removeItem(key);
            chatDebugLog('guestHistory', '[guest-history] storage:remove', {
                key,
                type,
            });
        } catch (e) {
            console.error(`[guest-history] storage:remove-failed:${type}`, {
                key,
                error: e?.message || String(e),
            });
        }
    }
};
